export default "__VITE_PUBLIC_ASSET__e10f7db6__"